import { Injectable } from '@angular/core';

@Injectable()
export class UtilityService {

  private days = [{ "day": "Sun" }, { "day": "Mon" }, { "day": "Tue" }, { "day": "Wed" }, { "day": "Thu" }, { "day": "Fri" }, { "day": "Sat"}];
  
  private daysFull = [{ "day": "Sunday" }, { "day": "Monday" }, { "day": "Tuesday" }, { "day": "Wednesday" }, { "day": "Thursday" }, { "day": "Friday" }, { "day": "Saturday"}];
 private hours = [{ "hr": "12:00 AM","IsHalf" : false },{ "hr": "12:30 AM","IsHalf" : true }, { "hr": "01:00 AM","IsHalf" : false },{ "hr": "01:30 AM","IsHalf" : true }, { "hr": "02:00 AM" ,"IsHalf" : false},{ "hr": "02:30 AM","IsHalf" : true }, { "hr": "03:00 AM","IsHalf" : false} ,{ "hr": "03:30 AM","IsHalf" : true }, { "hr": "04:00 AM","IsHalf" : false} ,{ "hr": "04:30 AM","IsHalf" : true }, { "hr": "05:00 AM","IsHalf" : false} ,{ "hr": "05:30 AM","IsHalf" : true }, { "hr": "06:00 AM","IsHalf" : false},{ "hr": "06:30 AM","IsHalf" : true }, { "hr": "07:00 AM","IsHalf" : false},{ "hr": "07:30 AM","IsHalf" : true }, { "hr": "08:00 AM","IsHalf" : false},{ "hr": "08:30 AM","IsHalf" : true }, { "hr": "09:00 AM","IsHalf" : false},{ "hr": "09:30 AM","IsHalf" : true }, { "hr": "10:00 AM","IsHalf" : false},{ "hr": "10:30 AM","IsHalf" : true }, { "hr": "11:00 AM","IsHalf" : false},{ "hr": "11:30 AM","IsHalf" : true},{ "hr": "12:00 PM","IsHalf" : false },{ "hr": "12:30 PM","IsHalf" : true }, { "hr": "01:00 PM","IsHalf" : false  },{ "hr": "01:30 PM","IsHalf" : true }, { "hr": "02:00 PM","IsHalf" : false },{ "hr": "02:30 PM","IsHalf" : true }, { "hr": "03:00 PM","IsHalf" : false },{ "hr": "03:30 PM","IsHalf" : true }, { "hr": "04:00 PM","IsHalf" : false },{ "hr": "04:30 PM","IsHalf" : true }, { "hr": "05:00 PM","IsHalf" : false },{ "hr": "05:30 PM","IsHalf" : true }, { "hr": "06:00 PM","IsHalf" : false},{ "hr": "06:30 PM","IsHalf" : true }, { "hr": "07:00 PM","IsHalf" : false},{ "hr": "07:30 PM","IsHalf" : true }, { "hr": "08:00 PM","IsHalf" : false},{ "hr": "08:30 PM","IsHalf" : true }, { "hr": "09:00 PM","IsHalf" : false},{ "hr": "09:30 PM","IsHalf" : true }, { "hr": "10:00 PM","IsHalf" : false},{ "hr": "10:30 PM","IsHalf" : true }, { "hr": "11:00 PM","IsHalf" : false}, { "hr": "11:30 PM","IsHalf" : true}];
 
  private monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	public monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  constructor() { }

 
  private daysInMonth = (month : number, year : number) : number => {
     return new Date(year, month, 0).getDate();
  };
  getWeekDaysNameList = () : object[] => {
     return this.days;
  };
  getWeekDaysNameWithDateList = (startDate : string) : object[] => {
    let daysList = [];
    let curr = new Date(parseInt(startDate.split('-')[0]), parseInt(startDate.split('-')[1]) -1,parseInt(startDate.split('-')[2]));;
    daysList.push({"day" : this.days[0].day + ' ' + (curr.getMonth() + 1) + '/' + curr.getDate() });
    for(let i=1; i<=6; i++) {
        curr = this.addDays(curr,1);
        daysList.push({"day" : this.days[i].day + ' ' + + (curr.getMonth() + 1) + '/' + curr.getDate()})
    }
    return daysList;
 };
 getNameWithDateList = (startDate : string) : object[] => {
   //debugger;
    let daysList = [];
    let curr = new Date(parseInt(startDate.split('-')[0]), parseInt(startDate.split('-')[1]) -1,parseInt(startDate.split('-')[2]));;
    daysList.push({"day" : this.daysFull[curr.getDay()].day});
        return daysList;
  };

  getCurrentDate = () : Date => {
    return new Date();
  };
  addDays(theDate, days) {
    return new Date(theDate.getTime() + days*24*60*60*1000);
  };
  substractDays(theDate, days) {
    return new Date(theDate.getTime() - days*24*60*60*1000);
  }
  getPreviousWeek = (week : string) : string => {
     let weekList =  week.split(' ');
     let curr = new Date(parseInt(weekList[0].split('-')[0]), parseInt(weekList[0].split('-')[1]) -1,parseInt(weekList[0].split('-')[2]));;
     var firstday =this.substractDays(curr,7);
     var lastday = this.substractDays(curr,1);
    return firstday.getFullYear() + '-' + (firstday.getMonth() + 1) + '-' + firstday.getDate() + ' ' + lastday.getFullYear() + '-' + (lastday.getMonth() + 1) + '-' + lastday.getDate();
  };
  getNextWeek = (week : string) : string => {
    let weekList =  week.split(' ');
    let curr = new Date(parseInt(weekList[1].split('-')[0]), parseInt(weekList[1].split('-')[1]) -1,parseInt(weekList[1].split('-')[2]));;
    var firstday =this.addDays(curr,1);
    var lastday = this.addDays(curr,7);
    return firstday.getFullYear() + '-' + (firstday.getMonth() + 1) + '-' + firstday.getDate() + ' ' + lastday.getFullYear() + '-' + (lastday.getMonth() + 1) + '-' + lastday.getDate();
  };
  getCurrentWeek = () : string => {
    let curr = this.getCurrentDate();
    let firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
    let lastday = new Date(curr.setDate(curr.getDate() - curr.getDay()+6));
    return firstday.getFullYear() + '-' + (firstday.getMonth() + 1) + '-' + firstday.getDate() + ' ' + lastday.getFullYear() + '-' + (lastday.getMonth() + 1) + '-' + lastday.getDate();
  };
  getWeekPage = (startDate: string, hours: any[] ) :  object[] => {
   let daysList = [];
       let hrs: any[] = [];
    for(let item of hours) {
      hrs.push({ "hr": item.SlotDescription,"IsHalf" : false });
    } 
   //for(let item of this.hours) {
     let itemIndex = 0;
    for(let item of hrs) {
      let weekDaysData = [];
      itemIndex = itemIndex  + 1;
      let curr = new Date(parseInt(startDate.split('-')[0]), parseInt(startDate.split('-')[1]) -1,parseInt(startDate.split('-')[2]));;
        let counter = 0; 
       for(let x=0; x<=6; x++) {
          curr = this.addDays(curr,counter);
          counter = 1;
          let day = curr.getDate();
          let date = day.toString();
          if(day<10) {
            date = '0'+date;
          }  
            if(item.IsHalf) {
              let time = ":59 PM"
              if(item.hr.indexOf('AM')>-1) {
                time = ":59 AM"
              }
              weekDaysData.push({"date" : curr.getDate(), "fulldate": date + "-" + this.monthShortNames[curr.getMonth()] + "-" + curr.getFullYear()  , "data":[], "startTime" : item.hr,"endTime": item.hr.split(':')[0]+time});
            } else {
              let time = ":29 PM"
              if(itemIndex !==hrs.length) {
                let t= hrs[itemIndex].hr.split(' ')[0].split(':')[1];
                let abb = hrs[itemIndex].hr.split(' ')[1];
                if(hrs[itemIndex].hr =="12:00 PM") {
                  time = ":59 AM"
                } else if(hrs[itemIndex].hr =="12:00 AM") {
                  time = ":59 PM"
                } else {
                  if(t==0) {
                    time = ":59 " +abb;
                  } else {
                    time = ":" + (parseInt(t) - 1) + ' ' +abb
                  }
                  
                }
              }  
              //if(item.hr.indexOf('AM')>-1) {
              //  time = ":29 AM"
            //  }
              weekDaysData.push({"date" : curr.getDate(), "fulldate": date + "-" + this.monthShortNames[curr.getMonth()] + "-" + curr.getFullYear()  , "data":[], "startTime" : item.hr,"endTime": item.hr.split(':')[0]+time});

            }
                   
      }
      daysList.push({"day" : "","time" : item.hr, "isHalf" : item.IsHalf,"days":weekDaysData})

   }
     return daysList;
  }
  getDayPage = (startDate: string, hours: any[]) :  object[] => {
    let daysList = [];
    let hrs: any[] = [];
    for(let item of hours) {
      hrs.push({ "hr": item.SlotDescription,"IsHalf" : false });
    }    
    //for(let item of this.hours) {
      let itemIndex = 0;
    for(let item of hrs) { 
       let weekDaysData = [];
       itemIndex = itemIndex  + 1;
       let curr = new Date(parseInt(startDate.split('-')[0]), parseInt(startDate.split('-')[1]) -1,parseInt(startDate.split('-')[2]));;
        
           let day = curr.getDate();
           let date = day.toString();
           if(day<10) {
             date = '0'+date;
           }  
             if(item.IsHalf) {
               let time = ":59 PM"
               if(item.hr.indexOf('AM')>-1) {
                 time = ":59 AM"
               }
               weekDaysData.push({"date" : curr.getDate(), "fulldate": date + "-" + this.monthShortNames[curr.getMonth()] + "-" + curr.getFullYear()  , "data":[], "startTime" : item.hr,"endTime": item.hr.split(':')[0]+time});
             } else {
               //let time = ":29 PM"
               //if(item.hr.indexOf('AM')>-1) {
              //   time = ":29 AM"
              // }
              let time = ":29 PM"
              if(itemIndex !==hrs.length) {
                let t= hrs[itemIndex].hr.split(' ')[0].split(':')[1];
                let abb = hrs[itemIndex].hr.split(' ')[1];
                if(hrs[itemIndex].hr =="12:00 PM") {
                  time = ":59 AM"
                } else if(hrs[itemIndex].hr =="12:00 AM") {
                  time = ":59 PM"
                } else {
                  if(t==0) {
                    time = ":59 " +abb;
                  } else {
                    time = ":" + (parseInt(t) - 1) + ' ' +abb
                  }
                  
                }
              }  
               weekDaysData.push({"date" : curr.getDate(), "fulldate": date + "-" + this.monthShortNames[curr.getMonth()] + "-" + curr.getFullYear()  , "data":[], "startTime" : item.hr,"endTime": item.hr.split(':')[0]+time});
 
             }
                    
        
       daysList.push({"day" : "","time" : item.hr, "isHalf" : item.IsHalf,"days":weekDaysData})
 
    }
      return daysList;
   }
  formatWeekName =(week : string) : string => {
    var weelkList = week.split(' ');
    if(weelkList[0].split('-')[0] === weelkList[1].split('-')[0]) {
        if(weelkList[0].split('-')[1] === weelkList[1].split('-')[1]) {
            return  this.monthShortNames[parseInt(weelkList[0].split('-')[1]) - 1]+ " "+ weelkList[0].split('-')[2] +" - "+ weelkList[1].split('-')[2] + ", " + weelkList[0].split('-')[0];
        } else {
            return  this.monthShortNames[parseInt(weelkList[0].split('-')[1]) - 1]+ " "+ weelkList[0].split('-')[2] +" - "+ this.monthShortNames[parseInt(weelkList[1].split('-')[1]) - 1] + " " + weelkList[1].split('-')[2] + ", " + weelkList[0].split('-')[0];
        }
    } else {
        return  this.monthShortNames[parseInt(weelkList[0].split('-')[1]) - 1]+ " "+ weelkList[0].split('-')[2] +", " + weelkList[0].split('-')[0]+" - "+ this.monthShortNames[parseInt(weelkList[1].split('-')[1]) - 1] + " " + weelkList[1].split('-')[2] + ", " + weelkList[1].split('-')[0];

    }
   
  };
  formatDayName =(day : Date) : string => {
    return this.monthNames[day.getMonth()] + ' ' + day.getDate() + ', ' + day.getFullYear();
  };
  getHoursForDay = () : object[]=> {
    return this.hours;
  }
  getSelectedMonthDetail = (month : number, year : number) : string => {
    return  this.monthNames[month] +", "+ year;
  };
  getSelectedWeekDetail = (month : number, year : number) : string => {
    return  this.monthNames[month] +", "+ year;
  }
  getMonthPage = (year : number, month : number, date : number) : object[] => {
        let sDt = new Date(year, month, date);
        let currentMonth = sDt.getMonth();
        let currentYear = sDt.getFullYear();
        let totalDays = this.daysInMonth((currentMonth + 1), currentYear);
        let monthArray = new Array();
        let weekFDay = new Date(year, month, 1).getDay();
        let remFirstWeekDay = 7 - weekFDay;
        let remDay = totalDays - remFirstWeekDay;
        var remWeek = remDay / 7;
        if (remDay % 7 != 0) {
            remWeek = parseInt(remWeek.toString().substr(0,1)) + 1;
        }
        let totalWeek = parseInt(remWeek.toString().substr(0,1)) + 1;
        let i = 0;
        for (i = 0; i < totalWeek; i++) {
          var weekArr = new Array(7)
            monthArray.push(weekArr);
        }
        let nIndex = 0;
        let mIndex = 0;
        let x = 0;
        for (x = 0; x <= weekFDay; x++) {
            if (x < weekFDay) {
                monthArray[0][x] = "";
            } else {
                monthArray[0][x] = 1;
                nIndex = x + 1;
            }

        }
        var currentDate = 1;
        for (x = nIndex; x < 7; x++) {
            currentDate = currentDate + 1
            monthArray[0][x] = currentDate;
        }
        var counter = 0;
        mIndex = mIndex + 1;
        for (i = currentDate + 1; i <= totalDays; i++) {
            if (counter == 7) {
                mIndex = mIndex + 1;
                counter = 0;
                monthArray[mIndex][counter] = i;
            } else {
                monthArray[mIndex][counter] = i;
            }
            counter++;
        }
        for(i=0; i<monthArray[monthArray.length-1].length;i++) {
          if(monthArray[monthArray.length-1][i]!==undefined) {
            continue;
          } else {
            monthArray[monthArray.length-1][i] = "";
          }
          
        }
        let dayArray = new Array();
       
        for (i = 0; i < monthArray.length; i++) {

            let objArr = this.getWeekDaysList(monthArray[i],this.monthShortNames[currentMonth] , currentYear);
             dayArray.push(objArr);
        }
        return dayArray;
  }
  private getWeekDaysList = (arr, month, year) : object[] => {
    let weekDaysData = [];
    for (let i = 0; i < arr.length; ++i) {
        if (arr[i] !== undefined) {
            if (arr[i] != "") {
              if(parseInt(arr[i])<10) {
                weekDaysData[i] = {"date" : arr[i], "fulldate": '0'+arr[i] + "-" + month + "-" + year  , "data":[], "startTime" : "12:00 AM","endTime": "11:59 PM"};
              } else {
                weekDaysData[i] = {"date" : arr[i], "fulldate": arr[i] + "-" + month + "-" + year  ,"data":[], "startTime" : "12:00 AM","endTime": "11:59 PM"};
              }     
            } else {
                weekDaysData[i] = {"date" : ""};
            }          
        }
    }
    return weekDaysData;
};
}



// WEBPACK FOOTER //
// ./src/app/section/appointment/calendar/utility.service.ts